import { useEffect, useState } from "react";
import { Table, Tag, Button } from "antd";
import moment from "moment";
import useLoteNotificacionAPI, { LoteNotificacionResumen, MedioNotificacion, TIPO_LOTE_DISPLAY, tipoLoteLabel } from "../hooks/useLoteNotificacionAPI";
import LoteNotificacionDetalleModal from "./LoteNotificacionDetalleModal";

const PAGE_SIZE = 20;

const medioLabel = (medio: MedioNotificacion) => {
    switch (medio) {
        case "EMAIL": return <Tag color="blue">EMAIL</Tag>;
        case "POSTAL": return <Tag color="gold">POSTAL</Tag>;
        case "WHATSAPP": return <Tag color="green">WHATSAPP</Tag>;
        default: return <Tag>-</Tag>;
    }
};

const tipoTag = (tipo: number | string) => {
    const { texto, color } = TIPO_LOTE_DISPLAY[tipoLoteLabel(tipo)];
    return <Tag color={color}>{texto}</Tag>;
};

export default () => {
    const api = useLoteNotificacionAPI();
    const [items, setItems] = useState<LoteNotificacionResumen[]>([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [detalleLoteId, setDetalleLoteId] = useState<number | null>(null);

    const load = async () => {
        setLoading(true);
        const result = await api.listarHistorialLotes({
            $count: true,
            $top: PAGE_SIZE,
            $skip: (page - 1) * PAGE_SIZE,
        });
        setItems(result.data?.value ?? []);
        setTotal(result.data?.["@odata.count"] ?? 0);
        setLoading(false);
    };

    useEffect(() => {
        load();
    }, [page]);

    return (
        <>
            {/* El progreso (exitosas/fallidas/pendientes) solo lo da el endpoint de estado por
                lote (Notificacion/email/lote/{id}/estado), no este listado genérico — se ve
                al abrir "ver detalle". Para lotes postales el envío ya es síncrono y completo. */}
            <LoteNotificacionDetalleModal
                loteNotificacionId={detalleLoteId}
                open={detalleLoteId != null}
                onClose={() => setDetalleLoteId(null)}
            />
            <Table
                rowKey="Id"
                loading={loading}
                dataSource={items}
                pagination={{ current: page, pageSize: PAGE_SIZE, total, onChange: setPage }}
            >
                <Table.Column title="Nro. lote" dataIndex="Id" />
                <Table.Column
                    title="Fecha"
                    dataIndex="FechaHora"
                    render={(fecha: string) => moment(fecha).format("DD/MM/YYYY HH:mm:ss")}
                />
                <Table.Column title="Medio" dataIndex="Medio" render={medioLabel} />
                <Table.Column title="Tipo" dataIndex="Tipo" render={tipoTag} />
                <Table.Column title="Actas" dataIndex="CantidadActas" />
                <Table.Column
                    title="Usuario"
                    dataIndex="UsuarioGenerador"
                    render={(usuario?: { UserName: string }) => usuario?.UserName ?? "-"}
                />
                {/* Lote de impresión de origen: se guarda en los envíos de Producción y Producción vencida
                    hechos desde esta pantalla. Los envíos por archivo (CSV) y las campañas quedan con "-". */}
                <Table.Column
                    title="Lote de impresión"
                    render={(_, record: LoteNotificacionResumen) => record.LoteImpresion?.NroLote ?? record.LoteImpresionId ?? "-"}
                />
                <Table.Column
                    title=""
                    render={(_, record: LoteNotificacionResumen) => (
                        <Button type="link" onClick={() => setDetalleLoteId(record.Id)}>Ver detalle</Button>
                    )}
                />
            </Table>
        </>
    );
};
